<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card>
          <div class=" d-flex align-center py-2 pa-2">
            <v-btn class="secondary--text mr-3 ml-2" @click="goBack" icon>
              <v-icon> mdi-arrow-left </v-icon>
            </v-btn>
            <v-divider vertical></v-divider>
            <h4 class="secondary--text font-weight-bold ml-6">
              {{ 
                $t(
                    'fleet_management.agents.agent_detail.labels.show_agent_toolbar_title'
                  )  
              }}
            </h4>
            <v-spacer></v-spacer>
            <v-btn
              v-if="showEditButton"
              id="idEventosEditar"
              @click="toggleEditable"
              color="secondary"
              text
            >
              <SvgIcon class="tertiary--text" iconType="icon_edit_pen" />
              <span class="text-capitalize">{{
                $t(
                  'fleet_management.persons.person_info.labels.card_edit_button'
                )
              }}</span>
            </v-btn>
          </div>
          <v-divider></v-divider>
          <v-container class="px-8 py-6">
            <v-row>
              <v-col>
                <component
                  @conditionsEmit="
                    editable => {
                      editableEmit(editable)
                    }
                  "
                  @newConditionsEmit="
                    createdby => {
                      newHandleEmit(createdby)
                    }
                  "
                  @formChanged="formChangedListener"
                  @thingsChangedEmit="
                    thingsChanged => {
                      thingsChangedEmit(thingsChanged, index)
                    }
                  "
                  @validConditionsEmit="
                    valid => {
                      validConditionsEmit(valid)
                    }
                  "
                  @temperatureMultiChanged="isTemperatureChanged = $event"
                  :is="'Conditions'"
                  :editable="editable"
                  ref="conditions"
                ></component>
              </v-col>
            </v-row>
          </v-container>
          <v-row>
            <v-col>
              <hr class="divider-dotted" />
            </v-col>
          </v-row>
          <v-container class="px-8 py-6">
            <v-row>
              <v-col>
                <BaseTag
                  assignedTagsDomElementId="idEventosEtiquetas"
                  tagsSelectAllDomElementId="idEventosSeleccionarTodoEtiquetas"
                  tagsSelectIndividualTagDomElementId="idEventosEtiqueta"
                  tagChipDomElementId="idEventosChipEtiqueta"
                  :editable="editable"
                  :tag-entities="getCurrentAgentTags"
                  :tag-entities-type="TagsHelpers.ENTITIE_TYPE.AGENTS"
                  @baseTagChange="value => baseTagEmit(value)"
                  ref="tagsAgentThingRefs"
                />
              </v-col>
            </v-row>
          </v-container>
          <v-row>
            <v-col>
              <hr class="divider-dotted" />
            </v-col>
          </v-row>
          <v-container class="px-8 py-6">
            <v-row v-if="isAdmin || isAdminSubFleet">
              <v-col>
                <Notifications
                  @validNotificationsEmit="
                    valid => {
                      validNotificationsEmit(valid)
                    }
                  "
                  @notificationErrorMessageEmit="
                    message => {
                      notificationErrorMessageEmit(message)
                    }
                  "
                  :onNotificationValueChange="onNotificationValueChange"
                  :isAdmin="isAdmin"
                  :isAdminSubFleet="isAdminSubFleet"
                  :editable="editable"
                  ref="notifications"
                >
                  <template
                    v-slot:tagsPersonSlot="{
                      tagsPersonIsEmpty,
                      baseTagDataSubmitted
                    }"
                  >
                    <BaseTag
                      :editable="editable"
                      :tag-entities="getCurrentAgentTags"
                      :tag-entities-type="TagsHelpers.ENTITIE_TYPE.PERSONS"
                      @baseTagChange="value => baseTagsPersonEmit(value)"
                      @tagsPersonIsEmpty="tagsPersonIsEmpty"
                      :baseTagDataSubmittedFn="baseTagDataSubmitted"
                      :label="!editable ? 'Grupo de personas' : ''"
                      ref="tagsPersonRefs"
                    />
                  </template>
                </Notifications>
              </v-col>
            </v-row>
          </v-container>
          <v-container class="px-8 py-6">
            <v-row v-show="editable">
              <v-col align="end">
                <div class="d-flex justify-space-between">
                  <v-btn
                    id="idBtnEventosCancelarEdicion"
                    depressed
                    outlined
                    rounded
                    @click="cancel"
                    >{{
                      $t(
                        'fleet_management.agents.create.labels.create_agent_form_cancel_button'
                      )
                    }}</v-btn
                  >
                  <v-btn
                    id="idBtnEventosGuardarEdicion"
                    @click="confirmChanges"
                    color="tertiary white--text"
                    depressed
                    :disabled="disableSaveButton"
                    :loading="submitLoading"
                    rounded
                    >{{
                      $t(
                        'fleet_management.agents.create.labels.create_agent_form_accept_button'
                      )
                    }}</v-btn
                  >
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card>

        <Dialog
          :idSubmitButton="'idEventosSiConfirmar'"
          :idCancelButton="'idEventosNoConfirmar'"
          :showDialog="showDialog"
          :text="dialog.text"
          :closeButtonText="dialog.closeButtonText"
          :submitButtonText="dialog.acceptButtonText"
          :oneButton="dialog.oneButtonDialog"
          :oneButtonText="dialog.oneButtonText"
          :type="dialog.type"
          :loading="dialog.loading"
          @cancelButtonPressed="cancelDialog"
          @submitButtonPressed="aceptDialog"
          @oneButtonAction="cancelDialog"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import store from '@/store'
import Dialog from '@/components/dialog/Dialog'
import { SvgIcon, firebaseServices } from '@leapsight/styleguide'
import { FirebaseTagNames } from '@leapsight/portal'
import Notifications from '../partials/notifications/Notifications'
import Conditions from '../partials/conditions/Conditions'
import { i18n } from '@leapsight/portal'
import { mapGetters } from 'vuex'
import BaseTag from '@/components/BaseTag.vue'
import agents from '@/views/Agents.vue'
import { TagsHelpers } from '@/helpers/mainExports'

export default {
  components: {
    BaseTag,
    Dialog,
    Notifications,
    Conditions,
    SvgIcon
  },
  props: {
    notification: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isTemperatureChanged: true,
      items: [
        { name: 'Detalle del Evento', data: Conditions, auth: false },
        { name: 'Detalle de Notificaciones', data: Notifications, auth: true }
      ],
      panel: [],
      recipientsHasBeenChanged: false,
      conditionEditable: false,
      notificationEditable: false,
      showDialog: false,
      routeTo: '',
      editable: false,
      isEditable: false,
      thingsChanged: false,
      formChanged: false,
      disabledByNotification: false,
      validCondition: true,
      validNotification: true,
      notificationErrorMessage: '',
      conditionsChange: false,
      baseTagsChange: false,
      baseTagsPersonChange: false,
      dataMessage: `${i18n.t(
        'fleet_management.agents.data_table.labels.data_table_no_data'
      )}`,
      dialog: {
        text: '',
        closeButtonText: 'No',
        acceptButtonText: 'Si',
        type: '',
        loading: false,
        oneButtonText: '',
        oneButtonDialog: false
      },
      createdBy: null,
      currentUser: localStorage.getItem('user_id')
    }
  },
  methods: {
    async aceptDialog() {
      this.dialog.loading = true

      if (this.baseTagsChange) await this.$refs.tagsAgentThingRefs.submit()

      if (this.baseTagsPersonChange) await this.$refs.tagsPersonRefs.submit()

      if (this.recipientsHasBeenChanged) await this.$refs.notifications.submit()
      if (this.conditionsChange) await this.$refs.conditions.submit()

      this.showDialog = false
      await this.$refs.conditions.getAgent()
      this.dialog.loading = false
      this.submitLoading = false
    },
    // Se deja armada la lógica de cambio de condiciones por si se necesitara a futuro; no se utiliza por el momento
    thingsChangedEmit(thingsChanged) {
      this.conditionsChange = !thingsChanged
    },
    formChangedListener(value) {
      this.formChanged = value
    },
    cancel() {
      this.toggleEditable()
      this.$refs.conditions.cancel()
      this.$refs.notifications.cancel()
      this.$refs.tagsAgentThingRefs.cancel()
      this.$refs.tagsPersonRefs.cancel()
    },
    cancelDialog() {
      this.showDialog = false
      this.submitLoading = false
    },
    confirmChanges() {
      this.submitLoading = true
      this.showDialog = true
      this.dialog.type = 'warning'
      this.dialog.text = i18n.t(
        'fleet_management.agents.alerts.confirm_changes'
      )
    },
    goBack() {
      this.$router.push({ name: 'Agents' })
    },
    toggleEditable() {
      firebaseServices.logEvent(
        firebaseServices.analytics,
        FirebaseTagNames.BTN_FLEET_MANAGEMENT_AGENT_EDIT
      )

      this.editable = !this.editable
    },
    editableEmit(editable) {
      this.editable = editable
    },
    newHandleEmit(createdby) {
      this.createdBy = createdby
    },
    validConditionsEmit(valid) {
      this.validCondition = valid
    },
    notificationsEmit(value) {
      this.disabledByNotification = value
    },
    baseTagEmit(value) {
      this.baseTagsChange = value
    },
    baseTagsPersonEmit(value) {
      this.baseTagsPersonChange = value
    },
    validNotificationsEmit(valid) {
      this.validNotification = valid
    },
    notificationErrorMessageEmit(valid) {
      this.notificationErrorMessage = valid
    },
    handleEditPermission(value) {
      this.isEditable = value
    },
    onNotificationValueChange(value) {
      this.recipientsHasBeenChanged = value
    }
  },
  computed: {
    TagsHelpers() {
      return TagsHelpers
    },
    agents() {
      return agents
    },
    ...mapGetters(['validationsTimeRestriction']),
    ...mapGetters('events', ['getCurrentAgentTags']),
    ...mapGetters(['isAdminSubFleet']),
    isAdmin() {
      return store.getters.isAdmin
    },
    showEditButton() {
      return (
        !this.editable &&
        (this.isAdmin || (this.isAdminSubFleet && !this.isEditable))
      )
    },
    formHasChanged() {
      return (
        this.recipientsHasBeenChanged ||
        this.formChanged ||
        this.baseTagsChange ||
        this.baseTagsPersonChange
      )
    },
    disableSaveButton() {
      return (
        !this.validCondition ||
        // !this.validNotification ||
        !this.validationsTimeRestriction ||
        !this.formHasChanged ||
        this.notificationErrorMessage !== '' ||
        !this.isTemperatureChanged
      )
    }
  },
  created() {
    this.$root.$on('agentHasMoreThanUser', this.handleEditPermission)
  },
  beforeDestroy() {
    this.$root.$off('agentHasMoreThanUser', this.handleEditPermission)
  }
}
</script>

<style lang="scss">
.v-expansion-panel-content__wrap {
  padding: 12px !important;
}
.v-expansion-panel {
  &.v-expansion-panel--active {
    #divider {
      top: 64px;
    }
  }
  #divider {
    transition: all 0.25s ease-in-out;
    position: absolute;
    background: var(--pale-sky-blue);
    top: 51px;
    left: 0;
    right: 0;
  }
}
</style>
